function focusSearchBar() {
  const searchContainer = document.querySelector("#menu-searchbar");
  if (!searchContainer) return;
  if (!searchContainer.classList.contains("hidden")) return;
  const searchBar = searchContainer.querySelector("input#s");
  if (!searchBar) return;
  setTimeout(() => searchBar.focus({ focusVisible: true }), 300);
}

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-jtoggle]").forEach((toggle) => {
    const targets = toggle.dataset.jtoggle
      .split(" ")
      .map((t) => {
        return document.getElementById(t);
      })
      .filter((t) => {
        return t !== null;
      });
    if (
      targets.length > 0 &&
      targets.filter((t) => t.id === "mobile-menu").length > 0
    ) {
      toggle.addEventListener("click", (ev) => {
        const target = ev.currentTarget;
        if (!target.classList.contains("toggle")) {
          const search = document.querySelector("#menu-searchbar");
          if (search && !search.classList.contains("hidden")) {
            search.classList.add("hidden");
          }
        }
      });
    }
  });

  document.querySelectorAll(".toggle-search")?.forEach((toggle) => {
    toggle.addEventListener("click", focusSearchBar);
  });
});
